import { useSelector } from 'react-redux';
import useProductLogsActions from './_actions';

export const useProductLogs = () => {
    const {
        fetchProductLogsList,
        changeCurrentPage,
        changeRowsPerPage,
        changeSearchTerm,
        changeUserType,
        changeStartDate,
        changeEndDate,
    } = useProductLogsActions();

    const logs = useSelector(state => state.productlogs.data);
    const currentPage = useSelector(state => state.productlogs.currentPage);
    const totalRows = useSelector(state => state.productlogs.totalRows);
    const rowsPerPage = useSelector(state => state.productlogs.rowsPerPage);
    const isLoading = useSelector(state => state.productlogs.isLoading);
    const isError = useSelector(state => state.productlogs.isError);
    const errorMessage = useSelector(state => state.productlogs.errorMessage);
    const searchTerm = useSelector(state => state.productlogs.searchTerm);
    const userType = useSelector(state => state.productlogs.userType);
    const start_date = useSelector(state => state.productlogs.start_date);
    const end_date = useSelector(state => state.productlogs.end_date);
    
    return {
        logs,
        currentPage,
        totalRows,
        rowsPerPage,
        isLoading,
        isError,
        errorMessage,
        searchTerm,
        userType,
        start_date,
        end_date,

        fetchProductLogsList,
        changeCurrentPage,
        changeRowsPerPage,
        changeSearchTerm,
        changeUserType,
        changeStartDate,
        changeEndDate
    }
}

export { default as productLogsReducer } from './_reducers';